"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Motion(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M14.5 2a2.5 2.5 0 0 1 2.111 1.163A2.502 2.502 0 0 1 20 5.5v.55a2.502 2.502 0 0 1 3 2.45V19c0 2.757-2.243 5-5 5h-4.3a4.963 4.963 0 0 1-3.562-1.488L3.286 15.53a1.001 1.001 0 0 1 .015-1.416c.85-.83 1.176-1.148 1.344-1.29a2.22 2.22 0 0 1 2.491-.27c.215.089.691.299 1.864.818V7a2.502 2.502 0 0 1 3-2.45V4.5C12 3.12 13.121 2 14.5 2zm0 2c-.275 0-.5.225-.5.5V13a1 1 0 1 1-2 0V7c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7.91a.999.999 0 0 1-1.405.915s-1.722-.764-2.673-1.183l-.272-.12c-.16-.07-.274-.12-.319-.138a1.128 1.128 0 0 1-.127-.06c-.202-.114-.213-.02-.249.012l-.027.023c-.079.072-.288.272-.511.488l6.146 6.263c.566.573 1.326.89 2.137.89H18c1.654 0 3-1.345 3-3V8.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5V14a1 1 0 1 1-2 0V5.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5V13a1 1 0 1 1-2 0V4.5c0-.275-.225-.5-.5-.5zM8 0a1 1 0 1 1 0 2C5.243 2 3 4.243 3 7a1 1 0 1 1-2 0c0-3.859 3.141-7 7-7zm0 3a1 1 0 1 1 0 2c-1.103 0-2 .897-2 2a1 1 0 1 1-2 0c0-2.206 1.794-4 4-4z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Motion;
